import React from 'react';
import { cn } from '@/lib/utils';
import './styles/textarea.css';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea ref={ref} className={cn('form-textarea', className)} {...props} />
  )
);

Textarea.displayName = 'Textarea';
